import { useState } from 'react';
import { X } from 'lucide-react';
import { GIST_VOICE_MAX_SECONDS, type GistVoiceReply } from '@london-life/contracts';
import { describeError } from '@london-life/errors';
import { api } from '../lib/api';
import { notify } from '../lib/alerts';
import { VoiceButton, VoicePlayer } from '../chat/voice';

export type GistVoice = GistVoiceReply['voice'];

// Gist's mic (as Lagos): Messages' hold-to-talk or tap for hands-free, up to two minutes; the recording is sent
// at once and put on the post or reply when it is posted
export function GistVoiceMic({ disabled, onVoice }: { disabled: boolean; onVoice: (voice: GistVoice) => void }) {
  const [sending, setSending] = useState(false);
  return (
    <VoiceButton
      canSend
      blockedText=""
      disabled={disabled || sending}
      maxSeconds={GIST_VOICE_MAX_SECONDS}
      doneLabel="Done"
      onNote={notify}
      onSend={async (recording, type, ms) => {
        setSending(true);
        try {
          onVoice((await api.gist.voice(recording, type, ms)).voice);
          return true;
        } catch (error) {
          notify(describeError(error).message);
          return false;
        } finally {
          setSending(false);
        }
      }}
    />
  );
}

// a voice note on a post or reply being written: listen back, or take it off
export function GistVoiceDraft({ voice, onRemove }: { voice: GistVoice; onRemove: () => void }) {
  return (
    <span className="gist-voice-draft">
      <VoicePlayer playPath={voice.playPath} durationMs={voice.durationMs} />
      <button type="button" aria-label="Remove the voice note" onClick={onRemove}>
        <X aria-hidden="true" />
      </button>
    </span>
  );
}
